import React from "react";
import { useParams } from "react-router-dom";
import { useLoginPolicy } from "../../../services/microservice/policy/auth/use-auth-policy";

const Banner = () => {
  const { clientID } = useParams();
  const { isError } = useLoginPolicy(clientID);

  return (
    <section className="bg-whiteSoft w-full">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-1 pt-24 lg:mx-auto lg:grid-cols-2">
          <div className="mb-28 ml-2 pt-10 lg:mb-24 lg:ml-24 lg:pt-36">
            <h1 className="text-textBlack text-center text-5xl font-semibold sm:text-left">
              {isError ? "Campaña finalizada" : "Activación"}
            </h1>
            <p className="text-textBlack mt-5 mr-4 text-center text-2xl sm:mr-0 sm:text-left">
              {isError
                ? "Esta campaña ha finalizado y no es posible registrar más dispositivos"
                : " ¡Es muy simple! Con tan solo 1 sencillo paso puedes realizar la activación de la garantía extendida."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
